
<mat-form-field class="example-full-width">
    <mat-label>Search submissions</mat-label>
    <input matInput placeholder="Enter text" (keyup)="searchTextKeyUp($event)" [(ngModel)]="searchText"> 
</mat-form-field>